import { render, staticRenderFns } from "./RoundDetailsHeaderParts.vue?vue&type=template&id=4af8dcae&scoped=true"
import script from "./RoundDetailsHeaderParts.vue?vue&type=script&lang=ts"
export * from "./RoundDetailsHeaderParts.vue?vue&type=script&lang=ts"
import style0 from "./RoundDetailsHeaderParts.vue?vue&type=style&index=0&id=4af8dcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8dcae",
  null
  
)

export default component.exports